
function Cockpit() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Cockpit.Home visual. <br/>
    /// It does the left-menu item handling, the notification handling and some browser-width fixing. 
    /// <br/>
    /// Author: ARF<br />
    /// Date: 9.10.2015<br />
    /// Copyright ©: EUDT GmbH 2015 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 18.1.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    // the following attributes got set in Charts.Cockpit.Home.vb
    this.day = "";
}

Cockpit.prototype = new vcTemplate();

Cockpit.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }


        me.showInfo("", "", false);

        //me.visual.find('.group .item').tipTip({defaultPosition:'bottom'});

        if (me.mobile === false) {
            me.visual.find("#divContentSub1").width(parseInt(me.visual.find("#divContentSub1").width(), 10) - parseInt(me.visual.find("#divCockpitMenu").width(), 10) - 20);
        }
        //adds the clickhandler for the menu items
        me.visual.find(".group .item").off("click").on("click", function () {
            me.loadContent($(this), false);
        });


        //loads the first menu item at the start
        me.loadContent($(me.visual.find(".group .item")[0]), true);

        //clickhandler for the currency icon
        me.visual.find("#divCurrency").off("click").on("click", function () {
            me.toggleCurrency($(this));
        });

        //loads the notifications
        if (me.HasAlarm) { me.loadAlarmNotes(); }
        if (me.HasNews) { me.loadNewsNotes(); }
        if (me.HasActivities) { me.loadActivityNotes(); }

        me.doEvent(null);
        return true;
    } catch (ex) { me.writeError('init', ex); return false }

}

Cockpit.prototype.toggleCurrency = function (obj) {
    /// <summary>
    /// This function switches between energy consumptions and euros. It reloads the currently selected menu item.  
    /// </summary>
    var me = this;
    try {
        obj.toggleClass("button-toggle-active");
        me.loadContent(me.currentMenu, false);

        return true;
    } catch (ex) { me.writeError('toggleCurrent', ex); return false; }
};

Cockpit.prototype.loadContent = function (obj, bInit) {
    /// <summary>
    /// This function loads the content for the given menu object/item. 
    /// On init it loads mandatory notes - if any exist - as well.
    /// </summary>
    var me = this;
    var visualname;
    var bsagid;
    var parameter = "";
    var signalparameter = "";
    var found = false;
    var height = 0;
    var bUsePrices;
    try {
        if (me.error) { return false; }
        if (obj.length === 0) { return false }

        //set the current menu item 
        me.currentMenu = obj;

        me.visual.find(".group .item").removeClass("selected");
        obj.addClass("selected");

        me.vcVisual.setShowSettings(false);
        me.vcVisual.setShowFullscreen(false);

        visualname = obj.attr("data-visual");
        bsagid = parseInt(obj.attr("data-bsagid"), 10);

        bUsePrices = me.visual.find("#divCurrency").hasClass("button-toggle-active");

        //CONTAINER_TACHO_SUMSIGNALS
        switch (visualname) {
            case "VISUAL_COCKPIT_SELECTION": signalparameter = JSON.stringify({ 'UsePrices': bUsePrices });  found = true; break;
            case "CONTAINER_DAILY_SUMSIGNALS": signalparameter = JSON.stringify({ 'UsePrices': bUsePrices, 'Interval': 1 }); found = true; break;
            case "CONTAINER_MONTHLY_SUMSIGNALS": signalparameter = JSON.stringify({ 'UsePrices': bUsePrices, 'Interval': 3 }); found = true; break;
            case "CONTAINER_ANALOG_SIGNALGROUP": signalparameter = JSON.stringify({ 'bsagid': bsagid, 'UsePrices': bUsePrices }); found = true; break;
            case "VISUAL_MENU_TOGGLE_ALARM": height = 1000; found = true; me.loadAlarmNotes(); break; //alarm history
            case "VISUAL_MENU_TOGGLE_ACTIVITY": height = 1050; found = true; me.loadActivityNotes(); break; //activities
            case "WIDGET_GALLERY_MENU": found = true; break; //docs
            case "VISUAL_MENU_TOGGLE_EVENT": found = true; parameter = ''; break; //interventions
            case "VISUAL_MASTER_MENU": found = true; parameter = ''; break;
            case "VISUAL_MASTER_LOGGERLIST": found = true; parameter = ''; break;
            case "WIDGET_MONITORINGICONS": found = true; parameter = ''; break; //interventions
            case "VISUAL_NOTIFICATION_LIST": found = true; parameter = ''; break; //notifiactions/news
            case "VISUAL_INPUT_READING": found = true; parameter = ''; break; //notifiactions/news
            case "VISUAL_DATACENTER_SINGLESIGNAL": found = true; parameter = ""; break; //notifiactions/news
        }

        if (found) {
            me.visual.find("#divContentSub1").html(me.vcC.getLoadingIcon());
            //jump to the top of the page
            window.scrollTo(0, 0);
           
            me.vcVisual.addVisualByName("divContent", visualname, 'Sub1', me.day, height, parseInt($("#divContentSub1").width(), 10), parameter, signalparameter, me.deviceType, function () {
                //load the mandatory notes the first time we load the content
                if (bInit) { me.loadMandatoryNotes(); }
            });
        }



        return true;
    } catch (ex) { me.writeError('loadContent', ex); return false }
}

Cockpit.prototype.loadAlarmNotes = function () {
    var me = this;
    try {
        if (me.error) { return false; }

        window.VisualCoreService.getDataByName('VISUAL_ALARMHISTORY', "-1", getCurrentTimestamp(), 0, 0, '', '', me.deviceType, '2',
            function (result) {
                return me.setNote("VISUAL_MENU_TOGGLE_ALARM", result);
            });
        return true;
    } catch (ex) { me.writeError('loadAlarmNotes', ex); return false }
}

Cockpit.prototype.loadActivityNotes = function () {
    var me = this;
    try {
        if (me.error) { return false; }
        window.VisualCoreService.getVisualLegendByName('WIDGET_ACTIVITY', "-1", getCurrentTimestamp(), 0, 0, '23:59,bdid,false,3,1', '', me.deviceType,
            function (result) {
                return me.setNote("VISUAL_MENU_TOGGLE_ACTIVITY", result);
            });

        return true;
    } catch (ex) { me.writeError('loadActivityNotes', ex); return false }
}

Cockpit.prototype.loadNewsNotes = function () {
    var me = this;
    try {
        if (me.error) { return false; }

        window.VisualCoreService.getDataByName('VISUAL_NOTIFICATION_LIST', "-1", getCurrentTimestamp(), 0, 0, '', '', me.deviceType, '',
            function (result) {
                return me.setNote("VISUAL_NOTIFICATION_LIST", result);
            });

        return true;
    } catch (ex) { me.writeError('loadNewsNotes', ex); return false }
}

Cockpit.prototype.setNote = function (dataVisual, result) {
    /// <summary>
    /// This function receives a notification for one menu point and sets the value or hides the notification if no note exists.
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        if (result === null) {
            me.visual.find(".group .item[data-visual='" + dataVisual + "'] .notification").show().html("ERR!");
            return false;
        }
        if (parseInt(result, 10) === -1) {
            me.visual.find(".group .item[data-visual='" + dataVisual + "'] .notification").show().html("ERR!");
            return false;
        }
        if (parseInt(result, 10) === 0) {
            me.visual.find(".group .item[data-visual='" + dataVisual + "'] .notification").hide().html(result);
            return true;
        }

        me.visual.find(".group .item[data-visual='" + dataVisual + "'] .notification").show().html(result);
        return true;

    } catch (ex) { me.writeError('setNote', ex); return false }
}

Cockpit.prototype.loadMandatoryNotes = function () {
    /// <summary>
    /// This function loads mandatory notes. If any note exists it hides every menu and only shows the mandatory notes a slong as every note has been commited.
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        me.vcVisual.addVisualByName("divMandatory", 'VISUAL_NOTIFICATION_LIST', 'Notes', me.day, parseInt(me.visual.find("#divContentSub1").height(), 10), parseInt(me.visual.find("#divContentSub1").width(), 10), JSON.stringify({ 'Mandatory': true }), '', me.deviceType, function () {

            if ($("#divMandatoryNotes").html().length > 100) {
                me.visual.find("#divContentSub1").html($("#divMandatoryNotes").html());
                me.visual.find("#divCockpitMenu").hide(0);
                $("#mainMenu, #adminPanel, #itemUserProfile, .divChangePwd").hide(0);
            }
        });
        return true;
    } catch (ex) { me.writeError('loadMandatoryNotes', ex); return false }
}

Cockpit.prototype.doEvent = function (event) {
    /// <summary>
    /// Not needed here right now ...
    /// </summary>
    var me = this;
    try {
        if (event !== null) {
            switch (event.msg) {
                /// sets the currently selected day
                case 'COCKPIT_SETDATE':
                    me.day = event.values;
                    break;
                case 'NEWS_NOTE_COMMITED':
                    me.loadNewsNotes();
                    break;
                case 'ACTIVITY_COMMITED':
                    me.loadActivityNotes();
                    break;
                default:
                    break;
            }
        }
    } catch (ex) { writeError('doEvent', ex); }
};

Cockpit.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('#divChart, #divContentSub1, #divCockpitMenu').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};


